"use client";

import { useEffect, useState } from "react";
import { ArrowRight, ArrowDown, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WebsiteDesignHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: dataCardRef,
    isVisible: dataCardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const [dragValue, setDragValue] = useState(0.218);
  useEffect(() => {
    const interval = setInterval(() => {
      const fluctuation = (Math.random() - 0.5) * 0.004;
      setDragValue(prev => {
        const next = prev + fluctuation;
        if (next < 0.210 || next > 0.225) return 0.218;
        return Math.round(next * 1000) / 1000;
      });
    }, 1200);
    return () => clearInterval(interval);
  }, []);
  return <section data-section-id="3056" id="website-design-hero" className="relative min-h-screen w-full overflow-hidden text-foreground !p-0 light bg-muted !h-[629.167px]">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704907/img/small_business_web_design.webp)]" />
      <div className="absolute inset-0 bg-background/70" />

      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-40 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704907/img/asahi_abstract_growth.png)] animate-[slowpan_30s_ease-in-out_infinite_alternate]" style={{
      mixBlendMode: "screen"
    }} />

      {}

      {}
      <Plus className="absolute top-6 left-6 size-6 text-foreground/40" strokeWidth={1} />
      <Plus className="absolute top-6 right-6 size-6 text-foreground/40" strokeWidth={1} />
      <Plus className="absolute bottom-6 left-6 size-6 text-foreground/40" strokeWidth={1} />
      <Plus className="absolute bottom-6 right-6 size-6 text-foreground/40" strokeWidth={1} />

      {}
      <div className="absolute top-12 left-12 z-20 flex items-center gap-3 font-mono text-[10px] uppercase tracking-widest text-foreground/80 md:top-14 md:left-14">
        <span className="border border-border px-2 py-1">[ASAHI] 01</span>
        <span className="text-foreground/60">/ SEARCH ENGINE ACTIVE</span>
        <span className="relative ml-1 inline-flex size-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-primary opacity-75" />
          <span className="relative inline-flex size-2 rounded-lg bg-primary" />
        </span>
      </div>

      {}
      <div className="absolute top-12 right-12 z-20 hidden font-mono text-[10px] uppercase tracking-widest text-foreground/70 md:top-14 md:right-14 md:block">
        PRECISION // GROWTH // AGENCY
      </div>

      {}
      <div className="relative z-20 flex min-h-screen w-full items-end px-6 pb-24 pt-32 md:px-14 md:pb-32 md:pt-0">
        <div className="w-full max-w-6xl">
          <div ref={headlineRef} className="transition-all duration-1000 ease-out translate-y-0 !opacity-[0.78]">
            {}
            

            {}
            <h1 className="font-default font-bold leading-[0.92] tracking-tighter text-foreground" style={{
            fontSize: "clamp(4rem, 11vw, 10rem)",
            letterSpacing: "-0.04em"
          }}>
              <span className="block !text-6xl"><span className="!text-5xl"><span className="![margin:20px_0px_20px_0px]"><span className="!text-7xl">Scale Your Small Business with Website Designed to Convert &nbsp;</span></span></span></span>
              
              
            </h1>

            {}
            <p className="mt-10 max-w-2xl font-default italic text-foreground/80" style={{
            fontSize: "22px",
            lineHeight: 1.4
          }}>Asahi Search helps small to medium businesses dominate their local markets through expert website design and SEO services.&nbsp;</p>

            {}
            <div className="mt-[60px] flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="#">
                <Button size="lg" className="group h-14 rounded-lg bg-primary px-8 font-default text-xs font-semibold uppercase tracking-widest text-primary-foreground shadow-lg hover:bg-primary/90">
                  Get a Free Website Design Quote
                  <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="#">
                <Button size="lg" variant="outline" className="h-14 rounded-lg border-foreground/40 bg-transparent px-8 font-default text-xs font-semibold uppercase tracking-widest text-foreground hover:bg-foreground/10 hover:text-foreground">
                  Learn About SEO Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div ref={dataCardRef} className={`absolute bottom-20 right-6 z-20 transition-all delay-300 duration-1000 ease-out md:right-14 ${dataCardVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        
      </div>

      {}
      

      {}
      <style>{`
        @keyframes slowpan {
          0% { transform: translate3d(0, 0, 0) scale(1.05); }
          100% { transform: translate3d(-2%, -1%, 0) scale(1.1); }
        }
      `}</style>
    </section>;
}